import uniqBy from 'lodash/uniqBy';
import { userTypes } from "../MyAccount/myaccount.constants";
import { commonEnvVariables } from "@/commonEnvVariables";
import { routerNames } from "@/components/appCommon.constants";

export const myToolsConstants = {
    MY_QUICK_LINKS: 'My Quick Links',
    FOLLOW_YPO_AT: 'Follow YPO at',
    SOCIAL_MEDIA_GUIDELINES: 'Social Media Guidelines',
    ADMINISTRATOR_TOOLS: 'Administrator Access',
    RESOURCES: 'Membership & Tools',
    POLICIES_TERMS: 'YPO Policies and Terms',
    FACEBOOK: 'Facebook',
    LINKEDIN: 'LinkedIn',
    INSTAGRAM: 'Instagram',
    TWITTER: 'Twitter',
    YOUTUBE: 'YouTube',
    My_ACCOUNT: 'My Account',
    SHARE_YOUR_IDEAS: 'Share Your Ideas',
    IDEAS_INTO_ACTION_LINK: 'Ideas Into Action Framework',
    LEARNING_DIRECTORY: 'Learning',
    CHAPTER_STUDIO: 'Chapter Studio',
    VIEW_ALL_NETWORKS: 'View All Networks',
    VIEW_ALL_GROUPS: 'View All Groups',
    FORUM_TOOLKIT: 'Forum Toolkit',
    FORUM_HUB: 'Forum Hub',
    FORUM_TOOLKIT_ID: 'forum_toolkit',
    FORUM_HUB_ID: 'forum_hub',
    YOUR_NETWORKS_CONSOLIDATED: 'Your Networks Consolidated',
    YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE: 'your networks consolidated',
    ALL_NETWORKS_COMMUNITY_ID: 'all_networks',
    VIEW_ALL_COMMUNITY_PILOTS: 'View All Communities Pilots',
    VIEW_ALL_COMMUNITY_PILOTS_ID: 'view_all_community_pilots',
    VIEW_ALL_COMMUNITIES_PILOT_LINK: 'https://www2.ypoconnect.org/topics/37504/page/home-79babcf8-e666-44ef-b78e-8c7a4e9fb4c2',
    ALL_GROUPS_LINK: 'https://www.ypoconnect.org/#/communityDirectoryPage?communityFilters=%7b%22CommunityType%22:%5b%7b%22label%22:%22Group%22%2c%22filterKey%22:%22CommunityType%22%2c%22filterValue%22:%22Group%22%2c%22isTypeAhead%22:false%2c%22subFilters%22:%5b%5d%2c%22count%22:401%2c%22ribbonGroupName%22:%22Community%20Type%22%2c%22isDropdown%22:false%7d%5d%2c%22CommunityFocus%22:%5b%5d%2c%22EligibilityRequirements%22:%5b%5d%7d&communitySearchText=',
    ALL_GROUPS_COMMUNITY_ID: 'all_groups',
    CHAPTER_STUDIO_ID: 'chapter_studio',
    MY_LEARNING: 'My Learning Journey',
    BUSINESS_COMMUNITY_TYPE: 'business',
    NETWORK_TERMS_CONDITIONS: 'networks terms & conditions',
    BECOME_A_CHAMPION: 'Become A Champion',
    BECOME_A_CHAMPION_ID: 'become_a_champion',
    administrator_tools_links: {
        regional_redirect_sso: {
            title: 'Home',
            link: commonEnvVariables().REGIONAL_REDIRECT_SSO_URL,
        },
        sales_force: {
            title: 'Salesforce',
            link: process.env.VUE_APP_SALESFORCE_URL,
        },
        cvent: {
            title: 'Cvent',
            link: `${process.env.VUE_APP_CVENT_URL}EventSelection`,
        },
        speaker_resource: {
            title: 'Speaker Resource',
            link: '',
        },
        workday: {
            title: 'Workday',
            link: 'https://www.myworkday.com/wday/authgwy/ypo/login.htmld?redirect=n',
        },
        chapter_management_hub: {
            title: 'Chapter Management Hub',
            link: `#/${routerNames.CHAPTER_MANAGEMENT}`,
        },
        chapter_studio: {
            title: 'Chapter Studio',
            link: `#/${routerNames.CHAPTER_STUDIO}`,
        },
        chapter_studio: {
            title: 'Chapter Studio',
            link: '#/chapterStudio',
        },
        manage_chapter_studio: {
            title: 'Manage Chapter Studio Announcements',
            link: `#/${routerNames.MANAGE_CHAPTER_STUDIO}`,
        },
        chapter_manager_community: {
            title: 'Chapter Manager Community',
            link: 'https://www2.ypoconnect.org/topics/20907/feed'
        },
        game_plan_request_form: {
            title: 'Game Plan Request form',
            link: 'https://app.smartsheet.com/b/form/cbd99d5463e54469985db4057129c575',
        },
        chapter_events_portal: {
            title: 'Chapter Events Portal',
            link: 'https://chapterevent.ypo.org/p/0024716e-a8ee-4beb-967f-83d89ba4dec9',
        },
        PEER_REVIEW_PANEL: 'Peer Review Panel',
        PEER_REVIEW_PANEL_ADMIN: 'Peer Review Panel Admin',
    },
        CHAPTER_ADMIN: 'Chapter Administrator',
        CHAPTER_MANAGER: 'Chapter Manager',
    QUICK_LINKS: {
        Forums: 'Forums',
        Chapters: 'Chapters',
        Regions: 'Regions',
        Networks: 'Networks',
        Groups: 'Groups',
        Resources: 'Resources',
        Forum: 'Forum',
        Chapter: 'Chapter',
        Region: 'Region',
        Network: 'Network',
        Group: 'Group',
        Resource: 'Resource',
        My_Forums: 'My Forum',
        My_Chapters: 'My Chapter',
        My_Regions: 'My Region',
        My_Networks: 'My Network',
        My_Groups: 'My Group',
        My_Resources: 'Resource',
        QuickLinks: 'QuickLinks',
        My_Quick_Links: 'My Quick Links',
        COMMUNITY_QUICK_LINKS: 'Community Quick Links',
        TWENTY_FOUR: 24,
        Manage_My_Quick_Links: 'Manage My Quick Links',
        info_text:
            'You can save up to 24 shortcuts to your Quick Links menu. Click and drag them to change the order in which they appear.',
        Success: 'You successfully changed your My Quick Links settings.',
        Error:
            'Due to technical issues, we are currently unable to change your My Quick Links settings. Please try again later.',
        My: 'My ',
        THE_SOURCE: 'The Source',
        EVENTS: 'Global Events',
    },
    rolesWithAccessToIdeasIntoAction: [
        userTypes.MEMBER,
        userTypes.TEAM_MEMBER,
        userTypes.CHAPTER_MANAGER,
        userTypes.CHAPTER_ADMINISTRATOR,
        userTypes.SPOUSE_PARTNER,
    ],
};
export const getUniqueQuickLinks = (links) => {
    return links && links.length ? uniqBy(links, ql => JSON.stringify([ql.name, ql.label])) : [];
};

export const addOrderToList = (list) => {
    if (list && list.length) {
        list.forEach((item, index) => {
            item.iconOrder = index;
        });
    }
    return list;
};

export const generateQuickLinkCategories = (categoryList, myQuickLinks) => {
    const result = [];
    result.push({
        key: myToolsConstants.QUICK_LINKS.QuickLinks,
        displayName: myToolsConstants.QUICK_LINKS.My_Quick_Links,
        links: myQuickLinks && myQuickLinks.length ? addOrderToList(myQuickLinks) : [],
    });

    Object.keys(categoryList).forEach((itemKey) => {
        result.push({
            key: itemKey,
            displayName: `${itemKey}s`,
            links: categoryList[itemKey],
        });
    });

    result.forEach((item) => {
        item.links = getUniqueQuickLinks(item.links);
    });

    return result;
};
